export default "__VITE_ASSET__DPeoyUZ8__"